module.exports = __webpack_public_path__ + "static/media/logo.df5e0413.svg";